import { render } from "./SidenavSection.vue?vue&type=template&id=a23e0234"
import script from "./SidenavSection.vue?vue&type=script&lang=js"
export * from "./SidenavSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__